import { render, staticRenderFns } from "./SupplierLoginDetailsModal.vue?vue&type=template&id=bbc8bd20&scoped=true"
import script from "./SupplierLoginDetailsModal.vue?vue&type=script&lang=js"
export * from "./SupplierLoginDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./SupplierLoginDetailsModal.vue?vue&type=style&index=0&id=bbc8bd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc8bd20",
  null
  
)

export default component.exports